import React, { useState, useEffect } from 'react';
import worksheetService from '../../services/worksheetService';

const WorksheetAuditModal = ({ isOpen, onClose, entityId, entityType = 'WorkItem' }) => {
  const [auditLogs, setAuditLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || !entityId) return;

    let isMounted = true;
    const loadAudit = async () => {
      setIsLoading(true);
      try {
        const res = await worksheetService.getAuditTrail(entityId, entityType);
        if (isMounted && res.success && res.data) {
          setAuditLogs(res.data);
        }
      } catch (err) {
        console.error('Failed to load worksheet audit trail:', err);
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    loadAudit();
    return () => {
      isMounted = false;
    };
  }, [isOpen, entityId, entityType]);

  if (!isOpen) return null;

  return (
    <div className="ws-modal-overlay" onClick={onClose}>
      <div
        className="ws-modal-card"
        style={{ width: '680px' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ws-modal-header">
          <div>
            <h3 style={{ margin: 0, fontSize: '16px', color: '#0f172a' }}>
              📜 Worksheet Audit History &amp; Chain of Custody
            </h3>
            <div style={{ fontSize: '12px', color: '#64748b', marginTop: '2px' }}>
              Tracking all bench transitions, hold reasons, retests, and timestamps
            </div>
          </div>
          <button
            type="button"
            className="ws-btn ws-btn-outline ws-btn-sm"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <div className="ws-modal-body" style={{ maxHeight: '420px', overflowY: 'auto' }}>
          {isLoading ? (
            <div style={{ padding: '30px', textAlign: 'center', color: '#64748b' }}>
              Loading audit records...
            </div>
          ) : auditLogs.length === 0 ? (
            <div style={{ padding: '30px', textAlign: 'center', color: '#64748b' }}>
              No audit logs recorded yet for this entity.
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {auditLogs.map((log) => (
                <div
                  key={log.auditId}
                  style={{
                    padding: '10px 14px',
                    border: '1px solid #e2e8f0',
                    borderRadius: '6px',
                    background: '#f8fafc',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontWeight: 700, color: '#0f172a', fontSize: '13px' }}>
                      {log.action}
                    </span>
                    <span style={{ fontSize: '11px', color: '#64748b' }}>
                      {new Date(log.createdDate).toLocaleString()}
                    </span>
                  </div>
                  <div style={{ fontSize: '12px', color: '#334155' }}>
                    Performed by: <strong>{log.username || 'System'}</strong> (ID: {log.userId})
                  </div>
                  {(log.oldValue || log.newValue) && (
                    <div style={{ fontSize: '11.5px', color: '#64748b' }}>
                      Status change: <del>{log.oldValue || 'None'}</del> ➔ <strong>{log.newValue}</strong>
                    </div>
                  )}
                  {log.reason && (
                    <div style={{ fontSize: '11.5px', color: '#92400e', background: '#fffbeb', padding: '4px 8px', borderRadius: '4px' }}>
                      Reason: <strong>{log.reason}</strong> {log.remarks ? `— ${log.remarks}` : ''}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="ws-modal-footer">
          <button type="button" className="ws-btn ws-btn-primary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default WorksheetAuditModal;
